export const getPreciosAdicionales = (product) => {
    return product.servicios_adicionales.filter(
        (servicio_adicional) => servicio_adicional.tipo === "Obligatorio"
    );
};
